import { useCallback, Fragment } from 'react';
import { Icon } from '@polichat/flamboyant';
import { QuickMessageSelectorOptions } from '../types/types';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import { QuickTypes } from '../types/constants';

import styles from '../QuickMessageSelector.module.css';
import { Sad } from '@poli-digital/react';

interface EmptyResultProps {
  type: QuickMessageSelectorOptions;
  role?: string;
}

export function EmptyResult({ type, role }: EmptyResultProps) {
  const noQuickMessageRegistered = useGlotaT('spa.chat.quickMessages.empty.noQuickMessage');
  const noTemplateRegistered = useGlotaT('spa.chat.quickMessages.empty.noTemplateRegistered');
  const needTemplateToStartConversation = useGlotaT('spa.chat.quickMessages.empty.needTemplateToStartConversation');
  const createTemplateIn = useGlotaT('spa.chat.quickMessages.empty.createTemplateIn');
  const settingsTemplateBuilder = useGlotaT('spa.chat.quickMessages.empty.settingsTemplateBuilder');
  const requestAdminToCreateTemplate = useGlotaT('spa.chat.quickMessages.empty.requestAdminToCreateTemplate');

  return (
    <div className={styles.empty_results}>
      <div>
        <span>
          <Sad color="" />
        </span>
        {type === QuickTypes.QUICK && <p>{noQuickMessageRegistered}</p>}

        {type !== QuickTypes.QUICK && (
          <Fragment>
            <p>{noTemplateRegistered}</p>
            <p>
              {needTemplateToStartConversation}
              <br />
              {role === 'adm' || role === 'manager' ? (
                <Fragment>
                  <span>
                    {createTemplateIn}
                    <i>{` ${settingsTemplateBuilder}`}</i>
                  </span>
                </Fragment>
              ) : (
                requestAdminToCreateTemplate
              )}
            </p>
          </Fragment>
        )}
      </div>
    </div>
  );
}
